/** @jsxImportSource @emotion/react */
import { Box, useTheme } from '@mui/material'
import { priorityHeader, priorityTable } from './PriorityTable.styles'
import { usePrioritisationContext } from '@app/contexts/ModuleContexts/PrioritisationContext'
import { FancySuspense } from '@app/components/Atoms/FancySuspense'
import { useState } from 'react'
import { Icon } from '@app/components/Atoms/Icon'
import { usePrioritisationMap } from '@app/contexts/ModuleMapContexts/PrioritisationMapContext'

export const PriorityTable = () => {
  const theme = useTheme()
  const {
    adaptationAreaPrioritiesIsLoading,
    adaptationAreaPrioritiesIsInitialized,
    adaptationAreaPriorities,
    area,
    setArea,
  } = usePrioritisationContext()
  const { selectedPrioLayer } = usePrioritisationMap()

  const [sortProp, setSortProp] = useState<'priorityIndex' | 'area'>('priorityIndex')
  const [sortAsc, setSortAsc] = useState(true)

  const clickHeader = (prop: 'priorityIndex' | 'area') => {
    if (prop === sortProp) {
      setSortAsc(!sortAsc)
    } else {
      setSortProp(prop)
      setSortAsc(true)
    }
  }

  return (
    <FancySuspense isLoading={!adaptationAreaPrioritiesIsInitialized} variant="table-2-col">
      <Box className="table" css={priorityTable(theme, adaptationAreaPrioritiesIsLoading)}>
        <Box className="thead">
          <Box className="td">
            <Box css={priorityHeader(sortAsc)} onClick={() => clickHeader('area')}>
              Adaptation area
              {sortProp == 'area' && <Icon iconName="s3://triangle" colour="#000" />}
            </Box>
          </Box>
          <Box className="td">
            <Box css={priorityHeader(sortAsc)} onClick={() => clickHeader('priorityIndex')}>
              Priority
              {sortProp == 'priorityIndex' && <Icon iconName="s3://triangle" colour="#000" />}
            </Box>
          </Box>
        </Box>
        <Box className="tbody">
          {adaptationAreaPriorities
            .sort((a, b) => {
              return (sortAsc ? 1 : -1) * a.area.localeCompare(b.area)
            })
            .filter((areaRow) => areaRow.areaGroup === selectedPrioLayer?.layer_type)
            .map((areaRow) => (
              <Box
                className={'tr ' + (areaRow.area === area ? 'selected' : '')}
                key={areaRow.area}
                onClick={() => {
                  if (!area || area !== areaRow.area) {
                    setArea(areaRow.area)
                  }
                }}
                css={{
                  order:
                    sortProp == 'priorityIndex' ? (sortAsc ? 1 : -1) * areaRow.priorityIndex : 0,
                }}
              >
                <Box className="td">{areaRow.area}</Box>
                <Box className="td">{areaRow.priorityIndex}</Box>
              </Box>
            ))}
        </Box>
      </Box>
    </FancySuspense>
  )
}
